import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

import { ErrorBoundary } from '../ErrorBoundary';
import ReactErrorUtil from '../Utilities/ReactErrorUtil';

class ReactErrorView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ErrorBoundary>
                <ReactErrorUtil />
            </ErrorBoundary>
        )
    }
}

export default ReactErrorView;
global.ReactErrorView = ReactErrorView;

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;